<template>
  <div>
    <v-container fluid>
      <v-row class="d-flex justify-center">
        <!-- Replace the existing date range picker with these two blocks -->
        <v-col cols="12" lg="2" md="2">
          <v-menu :close-on-content-click="false"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                  v-model="startDateMenu">
            <template v-slot:activator="{ on }">
              <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                <v-text-field
                    append-icon="event" dense
                    :label="$t('msg.start_date')" outlined readonly
                    v-model="filterCriteria.startDate"
                    v-on="on"
                ></v-text-field>
              </v-skeleton-loader>
            </template>
            <v-date-picker color="primary" no-title scrollable v-model="filterCriteria.startDate">
              <v-spacer></v-spacer>
              <v-btn @click="startDateMenu = false" color="primary" text>{{ $t('cancel') }}</v-btn>
              <v-btn @click="startDateMenu = false" color="primary" text>{{ $t('ok') }}</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" lg="2" md="2">
          <v-menu :close-on-content-click="false"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                  v-model="endDateMenu">
            <template v-slot:activator="{ on }">
              <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                <v-text-field
                    append-icon="event" dense
                    :label="$t('msg.end_date')" outlined readonly
                    v-model="filterCriteria.endDate"
                    v-on="on"
                    :disabled="!filterCriteria.startDate"
                ></v-text-field>
              </v-skeleton-loader>
            </template>
            <v-date-picker color="primary" no-title scrollable v-model="filterCriteria.endDate">
              <v-spacer></v-spacer>
              <v-btn @click="endDateMenu = false" color="primary" text>{{ $t('cancel') }}</v-btn>
              <v-btn @click="endDateMenu = false" color="primary" text>{{ $t('ok') }}</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <!-- Replace the existing scheme filter with these two columns -->
        <v-col v-if="isHQOfficer" cols="12" lg="2" md="2">
          <v-skeleton-loader :loading="loading" transition="scale-transition" type="card-heading">
            <v-select :items="subOrganizationItems"
                      :label="$t('msg.sub_org')"
                      chips deletable-chips dense outlined small-chips
                      class="contain-long-inputs"
                      item-text="text"
                      item-value="value"
                      v-model="selectedSubOrganization"
                      @change="onSubOrganizationChange">
            </v-select>
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="isHQOfficer" cols="12" lg="2" md="2">
          <v-skeleton-loader :loading="loading" transition="scale-transition" type="card-heading">
            <v-select :items="productItemsWithDefault"
                      :label="$t('msg.scheme')"
                      chips deletable-chips dense outlined small-chips
                      class="contain-long-inputs"
                      item-text="text"
                      item-value="value"
                      v-model="filterCriteria.scheme">
            </v-select>
          </v-skeleton-loader>
        </v-col>

        <v-col v-if="isLoanOfficer" cols="12" lg="2" md="2">
          <v-skeleton-loader :loading="loading" transition="scale-transition" type="card-heading">
            <v-select :items="productItems"
                      :label="$t('msg.scheme')"
                      chips deletable-chips dense outlined small-chips
                      class="contain-long-inputs"
                      item-text="text"
                      item-value="value"
                      v-model="filterCriteria.scheme">
            </v-select>
          </v-skeleton-loader>
        </v-col>

        <v-col cols="12" lg="3" md="3" class="d-flex justify-center">
          <v-skeleton-loader class="mr-3" :loading="loading" transition="scale-transition" type="button">
            <v-btn @click="filterData" color="primary">{{ $t('filter') }}</v-btn>
          </v-skeleton-loader>
          <v-skeleton-loader :loading="loading" transition="scale-transition" type="button">
            <v-btn @click="resetFilters" color="primary">{{ $t('reset') }}</v-btn>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-if="chartLoader">
        <v-col cols="12" lg="6" md="6" v-bind:key="index" v-for="(types,index) in loaderTypes">
          <v-skeleton-loader :loading="chartLoader" :type="types.type" transition="scale-transition"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6" md="6" v-bind:key="index" v-for="(charts,index) in firstChart">
          <v-card elevation="5">
            <PointChart :options="charts" v-if="charts !== null"></PointChart>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <v-card elevation="5">
            <BarChart :options="barChartData" v-if="barChartData !== null"></BarChart>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PointChart from "@/charts/PointChart";
import BarChart from "@/charts/BarChart";
import {dataServices} from "@/services";

export default {
  name: "Dashboard",
  components: {
    PointChart,
    BarChart
  },
  data() {
    return {
      filterCriteria: {
        startDate: null,
        endDate: null,
        scheme: null,
        subOrganisations: null,
      },
      startDateMenu: false,
      endDateMenu: false,
      firstChart: null,
      barChartData: null,
      computedStartDate: '',
      computedEndDate: '',
      chartLoader: true,
      currentDate: new Date().toJSON(),
      fromDate: null,
      toDate: null,
      programmeDropdown: [],
      branchDropdown: [],
      selectedSubOrganization: null,
      subOrganizationItems: [],
      productItems: [],
      productItemsFiltered: [],
      loading: false,
      filters: {},
      loaderTypes: [
        {type: 'card'},
        {type: 'card'},
        {type: 'card'},
        {type: 'card'}
      ]
    }
  },
  methods: {
    prepareDataForRequest: function () {
      this.filterCriteria.subOrganisations = this.selectedSubOrganization
    },
    chartData: function () {
      this.chartLoader = true
      this.firstChart = null
      this.barChartData = null
      this.loading = true
      this.prepareDataForRequest()
      dataServices.getChartData(this.filterCriteria).then(response => {
        if (response.dataResponse) {
          if (response.dataResponse.firstMap) {
            this.firstChart = response.dataResponse.firstMap
          }
          if (response.dataResponse.barChart) {
            this.barChartData = response.dataResponse.barChart
          }
        }
        this.loading = false
        this.chartLoader = false
      })
    },
    onSubOrganizationChange(subOrgId) {
      this.productItemsFiltered = [];
      this.filterCriteria.scheme = null;
      if (!subOrgId) {
        return;
      }
      this.productItemsFiltered = this.productItems.filter(
          (product) => product['parentKey'] == this.selectedSubOrganization
      );
    },

    homePageDropdown: function () {
      dataServices.getHomepageDropdown().then(response => {
        this.filters = response.dataResponse;

        // Initialize sub-organization items if scheme data exists
        if (this.filters.scheme) {
          this.productItems = this.filters.scheme;
          this.subOrganizationItems = this.filters.subOrganisations;
        }

        this.loading = false;
      });
    },
    filterData: function () {
      this.chartData()
    },
    resetDates: function () {
      this.filterCriteria.startDate = null
      this.filterCriteria.endDate = null
    },
    resetFilters: function () {
      this.filterCriteria.customerType = null
      this.filterCriteria.startDate = null
      this.filterCriteria.endDate = null
      this.filterCriteria.scheme = ''
      this.filterCriteria.branch = ''
      this.selectedSubOrganization = null
      this.filterCriteria.subOrganisations = null
      this.productItemsFiltered = []

      if (this.filters.scheme) {
        this.productItems = this.filters.scheme;
      }

      this.chartData()
    }
  },
  computed: {
    isHQOfficer() {
      return this.$store.state.home.user.roles.includes('ROLE_HQ_OFFICER');
    },
    isLoanOfficer: function () {
      return this.$store.state.home.user.roles.includes('ROLE_LOAN_OFFICER')
    },
    productItemsWithDefault() {
      if (!this.selectedSubOrganization) {
        return [{
          code: '',
          text: this.$t('msg.please_select_sub_organization')
        }];
      }
      return this.productItemsFiltered;
    },
    isDateRangeValid() {
      if (!this.filterCriteria.startDate) return true;
      if (!this.filterCriteria.endDate) return true;
      return new Date(this.filterCriteria.startDate) <= new Date(this.filterCriteria.endDate);
    },

    dateErrorMessage() {
      if (!this.isDateRangeValid) {
        return "End date must be after start date";
      }
      return "";
    }
  },
  watch: {
    'filterCriteria.startDate'(newVal) {
      // Clear end date if start date is cleared
      if (!newVal) {
        this.filterCriteria.endDate = null;
      }
      // If end date exists and is before new start date, clear end date
      else if (this.filterCriteria.endDate && new Date(newVal) > new Date(this.filterCriteria.endDate)) {
        this.filterCriteria.endDate = null;
      }
    },

    'filterCriteria.endDate'(newVal) {
      // Validate that end date is not before start date
      if (newVal && this.filterCriteria.startDate && new Date(newVal) < new Date(this.filterCriteria.startDate)) {
        // Optionally show error message or automatically adjust
        this.filterCriteria.endDate = null;
        // Or you could set it to start date:
        // this.filterCriteria.endDate = this.filterCriteria.startDate;
      }
    }
  },
  mounted() {
    if (this.$store.state.home.user.products.length === 1) {
      this.filterCriteria.customerType = this.$store.state.home.user.products[0]
    }
    this.chartData();
    this.homePageDropdown();
  }
}
</script>

<style>
.v-select--chips.contain-long-inputs .v-select__selections input {
  display: none;
}
</style>
